import { render, staticRenderFns } from "./MediabankImageList.vue?vue&type=template&id=a82ac270&"
import script from "./MediabankImageList.vue?vue&type=script&lang=js&"
export * from "./MediabankImageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports